import { all } from 'redux-saga/effects';

import store from './Store/Sagas';
import menu from './Menu/Sagas';

export default function* rootSaga() {
  return yield all([store, menu]);
}
